module.exports = __webpack_public_path__ + "img/painPerceptionScale_2.b237e088.png";